module.exports = __webpack_public_path__ + "img/visitas.7baf302c.svg";